import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Button,Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { headerLabel } from "assets/properties/properties";
import { removeUnderscores } from "utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import { getPreviousDateAccToDays } from "utils/Utils";
import { PreSanctionApprovalData } from "assets/properties/properties";
import { getApplicationFromDate } from "assets/properties/properties";
import useApplicantStatusData from "hooks/useApplicantStatusData";
import ViewDetailsLink from "../SendBackDetails/ViewDetailsLink";
import StageHistoryModal from "../SendBackDetails/StageHistoryModal";
import { parseAndSetFlag } from "utils/Utils";
const PreSanctionApproval = ({seletedBranchCode, featureFlags}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [fromDate,setFromDate] = useState(getApplicationFromDate());
  const [toDate,setToDate] = useState(new Date());
  const [stageHistoryModal, setStageHistoryModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
    const enabledSendBackStageDetails = parseAndSetFlag(
    featureFlags?.enabledSendBackStageDetails
  );
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
    useEffect(() => {
      if (location.state?.toastMessage) {
        toastUpdate(location.state.toastType, location.state.toastMessage, true);
    
        setTimeout(() => {
          navigate(location.pathname, { replace: true, state: {} });
        }, 100);
      }
    }, [location.key]);
  const handleFromDateChange = (e) => {
      setFromDate(e)
    }
    const handleToDateChange = (e) => {
      setToDate(e)
    }
  const {
    data: applicantData,
    error: applicantDataError,
    callInProgress: applicantDataLoading,
  } = useApplicantStatusData({
    status: "PRE_SANCTIONED",
    fromDate,
    toDate,
    authToken,
    featureFlags,
  });
  useEffect(() => {
    if (applicantDataError) {
      toastUpdate("Error", applicantDataError.user_description, true);
    } else {
      parseIndicatorData(applicantData);
    }
  }, [applicantData, applicantDataError]);

  const parseIndicatorData = (data) => {
    let reportData = [];
    data = data?.sort((a, b) =>
      a.loanApplicationId < b.loanApplicationId ? 1 : -1
    );
    data &&
      data.forEach((ForApprovalApplication, index) => {
        let row =  {
        applicationid: ForApprovalApplication.loanApplicationId,
        created: ForApprovalApplication.createdBy,
        formNumber: ForApprovalApplication.loanApplicationNumber,
        accountNumber: ForApprovalApplication.loanAccountNumber,
        customerid: ForApprovalApplication.customerId,
        customerName: ForApprovalApplication.customerName,
        mobile: ForApprovalApplication.mobileNumber?.trim(),
        type: `${removeUnderscores(ForApprovalApplication?.applicationType)} / ${removeUnderscores(ForApprovalApplication?.applicationSubType)}`,
        totalCollateralValue:ForApprovalApplication?.totalCollateralValue,
        productType: ForApprovalApplication?.productType,
        ...(enabledSendBackStageDetails
        ? {
            stageHistory: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {Number(
                  ForApprovalApplication?.applicationStageHistoryCount
                ) > 0 && (
                  <ViewDetailsLink
                    onClick={() => {
                      setSelectedLeadId(
                        ForApprovalApplication?.loanApplicationId
                      );
                      setStageHistoryModal(true);
                    }}
                  />
                )}
              </div>
            ),
          }
        : {}),
        collateralDescp:ForApprovalApplication?.collateralDescp,
        deviation:ForApprovalApplication?.deviation,
        }
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const onClickUpdateData = async (
    loanApplicationId, loanApplicationNumber, loanAccountNo, collateralDescp, deviation, customerName, productType
  ) => {
    const result = await apiHandler({
      url:
      endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}` ,
      authToken: authToken,
    });
        const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
    const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber ? result?.data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0];
        const navigationData = {
          loanApplicationId,
          loanAccountNo,
          status: PreSanctionApprovalData?.statusCode,
          subStatus: result?.data?.applicationSubType || "",
          prePledgeLoan: prepledgeLoanAccountNumber || "",
          editable: false,
          loanType: result?.data?.applicationType || "",
          collateralDescp,
          deviation,
          seletedBranchCode,
          customerName,
          prepledgeLoanMap:prepledgeLoanMap,
          productType
        };
      navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };
const tableColumns = enabledSendBackStageDetails
  ? [
      ...PreSanctionApprovalData.tableColumns,
      { id: "stageHistory", label: "Stage History" },
    ]
  : PreSanctionApprovalData.tableColumns;
  return (
    <Grid container>
    <Grid item xs={12} sm={12} md={12}>
      <SubHeader
        label={headerLabel?.preApproval}
        searchCriteria
        handleFromDateChange={handleFromDateChange}
        fromDate={fromDate}
        handleToDateChange={handleToDateChange}
        toDate={toDate}
      />
    </Grid>

    <Grid item xs={12} sm={12} md={12}>
      <ColumnGroupingTable columns={tableColumns} rows={selectedTableData} onClickUpdateData={onClickUpdateData} flag="preSanction"/>
    </Grid>
    <StageHistoryModal
      open={stageHistoryModal}
      onClose={() => {
        setStageHistoryModal(false);
        setSelectedLeadId(null);
      }}
      leadId={selectedLeadId}
      authToken={authToken}
    />
          {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
              {applicantDataLoading && <CircularProgresss callInProgress />}
  </Grid>
  );
};

PreSanctionApproval.propTypes = {
  classes: PropTypes.object,
};

export default PreSanctionApproval;
